import { useEffect, useState } from "react";
import { Bell, X, Calendar, Brain } from "lucide-react";
import api from "../lib/api";
import { useNavigate } from "react-router-dom";

export default function ReminderToasts() {
  const [items, setItems] = useState([]);
  const navigate = useNavigate();

  const load = async () => {
    try {
      const r = await api.get("/tests/pending-prompts");
      setItems(r.data || []);
    } catch (err) {
      console.warn("pending-prompts fetch failed", err);
    }
  };

  useEffect(() => {
    load();
    const id = setInterval(load, 60_000);
    return () => clearInterval(id);
  }, []);

  const dismiss = async (p) => {
    setItems((arr) => arr.filter((x) => x.id !== p.id));
    try {
      await api.post(`/tests/prompts/${p.id}/dismiss`);
    } catch (err) {
      console.warn("dismiss prompt failed", err);
    }
  };

  const open = async (p) => {
    await dismiss(p);
    if (p.category_id) navigate(`/glossary?category_id=${p.category_id}`);
    else navigate("/tests");
  };

  const quickQuiz = async (p) => {
    await dismiss(p);
    if (p.category_id) navigate(`/quiz?category_id=${p.category_id}&auto=1&n=5`);
    else navigate("/quiz");
  };

  if (!items.length) return null;
  const visible = items.slice(0, 3);

  return (
    <div className="fixed top-20 right-4 z-40 flex flex-col gap-3 max-w-sm" data-testid="reminder-stack">
      {visible.map((p) => (
        <div key={p.id} className="nb-card p-4 bg-yellow-100" data-testid={`reminder-${p.id}`}>
          <div className="flex items-start gap-3">
            <Bell className="w-5 h-5 mt-0.5 shrink-0" strokeWidth={2.5}/>
            <div className="flex-1 min-w-0">
              <h4 className="font-display font-bold text-sm">{p.title}</h4>
              <p className="text-sm text-slate-800 mt-0.5">{p.body}</p>
              <div className="flex flex-wrap gap-2 mt-3">
                <button onClick={() => open(p)} className="nb-btn-primary text-xs py-1.5 px-3 inline-flex items-center gap-1">
                  <Calendar className="w-3 h-3" strokeWidth={2.5}/> Open
                </button>
                {p.category_id && (
                  <button onClick={() => quickQuiz(p)} data-testid={`reminder-quiz-${p.id}`} className="nb-btn-secondary text-xs py-1.5 px-3 inline-flex items-center gap-1">
                    <Brain className="w-3 h-3" strokeWidth={2.5}/> Quiz me
                  </button>
                )}
                <button onClick={() => dismiss(p)} className="nb-btn-secondary text-xs py-1.5 px-3">Dismiss</button>
              </div>
            </div>
            <button onClick={() => dismiss(p)} className="text-slate-700 hover:text-slate-900" aria-label="Close">
              <X className="w-4 h-4" strokeWidth={2.5}/>
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
